import { Dispatch } from "react";
import { Action } from "redux";
import { ConfigReportEditSlice } from "./reducer";
import { ColdexAPI } from "../../../../apis/apiColdex/ColdexAPI";
import { IApiResult } from "../../../../utils/interfaces/store/IApiResponse";
import { ConfigReport } from "../../../../utils/types/ConfigReport";

export const ConfigReportEditEffect = {
  clean: () => {
    return async (dispatch: Dispatch<Action>) => {
      dispatch(ConfigReportEditSlice.actions.clean());
    };
  },
  setForm: (value: { id: string; value: string }) => {
    return async (dispatch: Dispatch<Action>) => {
      dispatch(ConfigReportEditSlice.actions.setForm(value));
    };
  },
  getOne: (id: string) => {
    return async (dispatch: Dispatch<Action>) => {
      dispatch(ConfigReportEditSlice.actions.getOne());

      ColdexAPI.get<IApiResult<ConfigReport>>(`benchreports/config-reports/${id}`)
        .then(({ data }) => {
          if (data.dataError) {
            dispatch(
              ConfigReportEditSlice.actions.getOneError({
                iserror: true,
                shorterror: data.shortMessage,
                error: data.resultMessage,
              })
            );
            return;
          }

          dispatch(
            ConfigReportEditSlice.actions.getOneSuccess(data.resultObject)
          );
        })
        .catch((error) => {
          dispatch(
            ConfigReportEditSlice.actions.getOneError({
              iserror: true,
              shorterror: `Error short`,
              error,
            })
          );
        });
    };
  },
  update: (configReport: ConfigReport) => {
    return async (dispatch: Dispatch<Action>) => {
      dispatch(ConfigReportEditSlice.actions.save());

      ColdexAPI.put<IApiResult<ConfigReport>>(
        `benchreports/config-reports/${configReport.id}`,
        configReport
      )
        .then(({ data }) => {
          if (data.dataError) {
            dispatch(
              ConfigReportEditSlice.actions.saveError({
                iserror: true,
                shorterror: data.shortMessage,
                error: data.resultMessage,
              })
            );
            return;
          }

          dispatch(
            ConfigReportEditSlice.actions.saveSuccess(data.resultObject)
          );
        })
        .catch((error) => {
          dispatch(
            ConfigReportEditSlice.actions.saveError({
              iserror: true,
              shorterror: `Error short`,
              error,
            })
          );
        });
    };
  },
};
